<template>
  <div class="period-selector">
    <button
      v-for="period in periodOptions"
      :key="period.value"
      class="period-btn"
      :class="{ active: selectedPeriod === period.value }"
      @click="onPeriodClick(period.value)"
    >
      {{ period.label }}
    </button>
  </div>
</template>

<script>
import { PERIODS, PERIOD_OPTIONS } from "@config/pricingConfig"

export default {
  name: "PeriodSelector",

  props: {
    selectedPeriod: {
      type: String,
      default: PERIODS.MONTHLY,
      validator: (value) => Object.values(PERIODS).includes(value),
    },
  },

  data() {
    return {
      periodOptions: PERIOD_OPTIONS,
    }
  },

  methods: {
    onPeriodClick(period) {
      if (period !== this.selectedPeriod) {
        this.$emit("period-change", period)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.period-selector {
  background: var(--bg-ui);
  display: inline-flex;
  justify-content: space-between;
  padding: 5px;
  border-radius: 50px;
  width: 96%;
}

.period-btn {
  border: none;
  background: transparent;
  padding: 10px 25px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 500;
  color: var(--tertiary-color);
  transition: all 0.3s ease;
  cursor: pointer;

  &.active {
    background: var(--tertiary-color);
    color: #fff;
  }

  &:hover:not(.active) {
    background: rgba(107, 31, 77, 0.1);
  }
}
</style>
